// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1AzTw","header":"MessagesList_header__1PB2_","chat":"MessagesList_chat__1qp_H"};